import React from "react";
import clsx from "clsx";

import withStyles from "@material-ui/core/styles/withStyles";
import {withTradesDataProvider} from "./components/TradesDataProvider";
import styles from "../RiskProfiling/styles";
import Container from "@material-ui/core/Container/Container";
import {CircularProgress, makeStyles} from "@material-ui/core";
import StepContentV2 from "../RiskProfiling/components/StepContent/StepContentV2";
import {RenderStepLoadingMessage} from "../../utils/utils";
import EinzeltitelProcessConfirmationModalContextProvider
  from "../RiskProfiling/components/EinzeltitelsProcessConfirmationProvider/EinzeltitelsProcessConfirmationProvider";
import {TabsSharedData} from "../CustomerDashboardV2/components_v2/TabsSharedData/TabsSharedData";

const Trades = props => {
  const {
    classes,
    onNextClick,
    onPrevClick,
    onGoToStepClick,
    onConfirmResultClick,
    onResendResultClick,
    onAnswerChange,
    step,
    isFirst,
    isLast,
    loading,
    dataService,
    extraRightButtons,
    isNewDesign,
  } = props;

  const useClasses = makeStyles(() => ({
    container: {
      '& > div': {
        marginTop: 0 // as we do not have progress bar override margin for it
      }
    }
  }));
  const customClasses = useClasses();

  return (
    <EinzeltitelProcessConfirmationModalContextProvider>
      <Container className={clsx(classes.container, customClasses.container)}>
        <TabsSharedData>
        {loading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress className={classes.loadingIndicator}/>
            {RenderStepLoadingMessage(step)}
          </div>
        ) : (
          <>
            <StepContentV2
              classes={classes}
              step={step}
              loading={loading}
              isFirst={isFirst}
              isLast={isLast}
              onNextClick={onNextClick}
              onPrevClick={onPrevClick}
              onGoToStepClick={onGoToStepClick}
              onConfirmResultClick={onConfirmResultClick}
              onResendResultClick={onResendResultClick}
              onAnswerChange={onAnswerChange}
              dataService={dataService}
              nextStepBtnText={dataService && dataService.next_btn}
              successBody={dataService && dataService.success_body}
              extraRightButtons={extraRightButtons}
              isNewDesign={isNewDesign}
            />
          </>
        )}
        </TabsSharedData>
      </Container>
    </EinzeltitelProcessConfirmationModalContextProvider>
  )
};

export default withTradesDataProvider(withStyles(styles)(Trades));